<template>
  <div>
    <el-card shadow="hover">
      <div slot="header">
        <el-row>
          <el-col :span="22" style="padding-top: 5px">Genomic distribution</el-col>
          <el-col :span="2">
            <span>
              <el-tooltip content="Explore more" placement="top" :enterable="false">
                <el-button circle size="mini" @click="handleModalOpen"><i class="fas fa-icon-expand"></i></el-button>
              </el-tooltip>
            </span>
          </el-col>
        </el-row>
      </div>
      <modal-unit-stack-anno-distribution :index="index" :series="annopieOptions" height="300px"></modal-unit-stack-anno-distribution>
    </el-card>
  </div>
</template>

<script>
  // import 'echarts/theme/shine.js'
  import { store } from '../scripts/store.js'
  import { events } from '../scripts/events.js'
  import { repeatAnnoDist } from '../scripts/utils.js';
  import ModalUnitStackAnnoDistribution from '../components/ModalUnitStackAnnoDistribution.vue'
  const _ = require('lodash');

  export default {
    name: 'MainPlotStackAnnoDistribution',
    props: {
      info: Object,
      index: Number
    },
    components: { ModalUnitStackAnnoDistribution },
    computed: {
      annopieOptions: function () {
        const plotdata = this.info.AnnoInfo.RepAnno;
        const annoKeyObj = {'Exon': ['EP', 'EN'], 'Intron': ['IP', 'IN'], 'Genic': ['GP', 'GN'], 'Intergenic': ['DP', 'DN']}
        const promKeyObj ={ 'Promoter': ['EP', 'IP', 'GP', 'DP'], 'Non-Promoter': ['EN', 'IN', 'GN', 'DN'] };

        const annoKeys = Object.keys(annoKeyObj);
        const promKeys = Object.keys(promKeyObj);


        let annodata = repeatAnnoDist(plotdata, 'all')
        let series = [];
        annoKeys.forEach(a => {
          if (annodata[a]!= 0){
            series.push({ name: a, type: 'bar', barWidth: '40%', stack: 'Annotation', data: [annodata[a]] })
          }
        })

        promKeys.forEach(p => {
          if (annodata[p] != 0){
            series.push({ name: p, type: 'bar', barWidth: '40%', stack: 'Promoter', data: [annodata[p]] })
          }
        })

        const xAxis = {
          type: 'value', min: 0, max: 100,
          name: 'Percentage',
          nameLocation: 'middle',
          nameGap: 30,
          margin: 8,
          nameTextStyle: {
            fontSize: 14,
            fontWeight: 'bold'
          },
        }
        series = { data: series, xAxis: xAxis, yAxis: { type: 'category', data: ['All repeats'], axisLabel: { rotate: 90 } } }
        return series;
        // return new Promise(resolve => setTimeout(() => resolve(series), this.index * store.settings.plotUpdateDelayFactor))
      }
    },
    methods: {
      handleModalOpen: function () {
        events.$emit('open-modal', 'ModalStackAnnoDistribution')
      }
    }
  }
</script>